import { motion, useReducedMotion } from 'framer-motion';

// Heritage watermark: a hairline (1px) white padel court outline drawn once,
// fading to 15% opacity as a permanent background — like an engraving on a
// members'-club noticeboard rather than an energetic reveal.
export const PadelCourtSVG = ({ className = '', animate = true }) => {
  const reduce = useReducedMotion();
  const shouldAnimate = animate && !reduce;
  const ease = [0.22, 1, 0.36, 1];

  const line = (delay, d, key, opts = {}) => (
    <motion.path
      key={key}
      d={d}
      fill="none"
      stroke="#f7f7f4"
      strokeWidth={1}
      strokeLinecap="round"
      initial={shouldAnimate ? { pathLength: 0, opacity: 0 } : { pathLength: 1, opacity: opts.finalOpacity || 0.15 }}
      animate={shouldAnimate ? { pathLength: 1, opacity: opts.finalOpacity || 0.15 } : { pathLength: 1, opacity: opts.finalOpacity || 0.15 }}
      transition={shouldAnimate ? { duration: 2.4, delay, ease } : {}}
    />
  );

  return (
    <svg
      className={className}
      viewBox="0 0 800 480"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {line(0.1, 'M40 40 L760 40', 'top')}
      {line(0.2, 'M760 40 L760 440', 'right')}
      {line(0.3, 'M760 440 L40 440', 'bottom')}
      {line(0.4, 'M40 440 L40 40', 'left')}
      {line(0.6, 'M40 240 L760 240', 'net', { finalOpacity: 0.2 })}
      {line(0.7, 'M40 232 L40 248', 'post-l')}
      {line(0.7, 'M760 232 L760 248', 'post-r')}
      {line(0.75, 'M40 110 L760 110', 'service-top')}
      {line(0.8, 'M40 370 L760 370', 'service-bot')}
      {line(0.85, 'M400 110 L400 240', 'center-top')}
      {line(0.9, 'M400 240 L400 370', 'center-bot')}
      {line(0.95, 'M40 40 L140 40 M40 40 L40 140', 'corner-tl', { finalOpacity: 0.1 })}
      {line(1.0, 'M760 40 L660 40 M760 40 L760 140', 'corner-tr', { finalOpacity: 0.1 })}
      {line(1.05, 'M40 440 L140 440 M40 440 L40 340', 'corner-bl', { finalOpacity: 0.1 })}
      {line(1.1, 'M760 440 L660 440 M760 440 L760 340', 'corner-br', { finalOpacity: 0.1 })}
    </svg>
  );
};

export default PadelCourtSVG;
